import { render, staticRenderFns } from "./incomeData.vue?vue&type=template&id=59b9e8ea&scoped=true"
import script from "./incomeData.vue?vue&type=script&lang=js"
export * from "./incomeData.vue?vue&type=script&lang=js"
import style0 from "./incomeData.vue?vue&type=style&index=0&id=59b9e8ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b9e8ea",
  null
  
)

export default component.exports